package cz.lhoracek.mapl.data.repository

import kotlinx.browser.window
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.contentOrNull
import kotlinx.serialization.json.jsonArray
import kotlinx.serialization.json.jsonPrimitive

private const val MAPL_KNOWN_SESSION_IDS_STORAGE_KEY = "known_session_ids"

actual class KnownSessionIds actual constructor() {
    private val state = MutableStateFlow(loadKnownIds())

    actual val ids: Flow<List<String>> = state

    actual suspend fun add(sessionId: String) {
        val normalized = sessionId.trim()
        if (normalized.isBlank()) return

        val updated = (state.value + normalized).distinct()
        state.value = updated
        persistKnownIds(updated)
    }

    actual suspend fun remove(sessionId: String) {
        val normalized = sessionId.trim()
        if (normalized.isBlank()) return

        val updated = state.value.filterNot { it == normalized }
        state.value = updated
        persistKnownIds(updated)
    }

    private fun loadKnownIds(): List<String> {
        val raw = window.localStorage.getItem(MAPL_KNOWN_SESSION_IDS_STORAGE_KEY) ?: return emptyList()
        return runCatching {
            Json.parseToJsonElement(raw).jsonArray.mapNotNull { it.jsonPrimitive.contentOrNull }
        }.getOrDefault(emptyList())
    }

    private fun persistKnownIds(ids: List<String>) {
        val serialized = JsonArray(ids.map(::JsonPrimitive)).toString()
        window.localStorage.setItem(MAPL_KNOWN_SESSION_IDS_STORAGE_KEY, serialized)
    }
}
